import { ReactNode } from 'react'
import { Box, Flex, Heading, Text } from '@radix-ui/themes'
import classNames from 'classnames'
import { ThemeColor } from '~/theme-utils'

export interface RichCalloutCardProps {
  color?: ThemeColor
  variant?: 'outline' | 'soft' | 'surface'
  title: string
  subtitle?: string
  icon: ReactNode
  children?: ReactNode
  actions?: ReactNode
}

export const RichCalloutCard = ({
  color = 'gray',
  variant = 'surface',
  title,
  subtitle,
  icon,
  children,
  actions
}: RichCalloutCardProps) => {
  const hasBody = !!children

  return (
    <Box
      className={classNames('rounded-lg border bg-[var(--color-panel)] p-0', {
        'border-0': variant === 'soft'
      })}
      style={{
        borderColor: variant !== 'soft' ? `var(--${color}-9)` : undefined
      }}
    >
      <Flex
        align="center"
        justify="between"
        className={classNames('border-b', {
          'rounded-lg border-none p-7': !hasBody,
          'rounded-t-lg p-4': hasBody,
          'border-none': variant === 'soft'
        })}
        style={{
          backgroundColor: variant !== 'outline' ? `var(--${color}-2)` : undefined,
          borderColor: variant !== 'soft' ? `var(--${color}-9)` : undefined
        }}
      >
        <Flex align="center" gap="3">
          {icon}
          <Flex direction="column">
            <Heading color={color} size={!hasBody ? '5' : '4'}>
              {title}
            </Heading>
            {subtitle && (
              <Text size="2" color="gray">
                {subtitle}
              </Text>
            )}
          </Flex>
        </Flex>
        {actions && (
          <Flex align="center" gap="2">
            {actions}
          </Flex>
        )}
      </Flex>

      {hasBody && (
        <Flex direction="column" gap="4" p="5">
          {children}
        </Flex>
      )}
    </Box>
  )
}
